import { generateStyleFlexUrl } from '@common/Product/helpers/styleflex';
import updateQueryParams from '@helpers/updateQueryParams';

export const generateSrc = (dimension, url, styleFlex = {}) => {
    if (typeof dimension !== 'string') {
        return url;
    }

    const size = `w${dimension?.split('x')?.[0] ?? '183'}`;

    /**
     * THIS IS FOR THE TEMPORARY POC UNTIL REPLACED BY BE
     */
    if (url && styleFlex?.enabled) {
        return generateStyleFlexUrl(styleFlex, url, size);
    }

    return url ? updateQueryParams(url, { size }) : '';
};

export const generateSrcSet = (availableImageDimensions = [], url, styleFlex = {}) => {
    const urls = availableImageDimensions.map((dimension) => {
        const width = dimension.split('x')[0];
        const src = generateSrc(width, url, styleFlex);
        return `${src} ${width}w`;
    });
    return urls.join(',');
};

export const generateImage = (imagesParameters, image, styleFlex = {}) => {
    const { dimension } = imagesParameters.imageSizes;
    const { is_model: isFullCardImage, url } = image;
    return {
        attributes: {
            src: generateSrc(dimension, url, styleFlex),
            srcSet: generateSrcSet(imagesParameters.availableImageDimensions, url, styleFlex),
            sizes: imagesParameters.imageSizes?.sizes_attribute,
            alt: image.alt
        },
        isFullCardImage
    };
};

export const generateAlternativeSrc = (imageAttributes, cardConfig) => {
    const { showAlternativeImage, imagesParameters } = cardConfig;

    if (showAlternativeImage && imageAttributes) {
        return generateImage(imagesParameters, imageAttributes);
    }

    return null;
};
